export const sideTone = side => side === "CE" ? "side-ce" : side === "PE" ? "side-pe" : "side-neutral";

export const decisionTone = value => {
  const text = String(value || "").toUpperCase();
  if (/REJECT|CANCEL|EXPIRE|BLOCK|WRONG|NOT_MET|ERROR|LOSS|LIMIT|CLOSED|OUT_OF_RANGE|REACHED/.test(text)) return "decision-blocked";
  if (/WAIT|PENDING|PAUSED|WARM|UNAVAILABLE/.test(text)) return "decision-waiting";
  if (/CONFIRM|ENTERED|OPEN|READY|PASS/.test(text)) return "decision-ready";
  return "decision-neutral";
};

export const openingGapPoints = row => {
  if (row.gap_points != null && Number.isFinite(Number(row.gap_points))) return Number(row.gap_points);
  if (row.session_open != null && row.previous_day_close != null &&
      Number.isFinite(Number(row.session_open)) && Number.isFinite(Number(row.previous_day_close))) {
    return Number(row.session_open) - Number(row.previous_day_close);
  }
  if (row.gap_pct != null && row.previous_day_close != null &&
      Number.isFinite(Number(row.gap_pct)) && Number.isFinite(Number(row.previous_day_close))) {
    return Number(row.previous_day_close) * Number(row.gap_pct) / 100;
  }
  return null;
};
